module.exports = __webpack_public_path__ + "img/oltasok_altalanos.288307aa.jpg";